<div *ngIf="!isLoadingTree">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-3 items-end">
    <div>
        <label [for]="'njuskalo-region-' + instanceId" i18n>Županija</label>
        <select [id]="'njuskalo-region-' + instanceId" [(ngModel)]="selectedRegion" (change)="onRegionChange($event)">
            <option value=""></option>
            <option *ngFor="let region of regions" [value]="region">{{ region }}</option>
        </select>
    </div>

    <div [hidden]="!showCities">
        <label [for]="'njuskalo-city-' + instanceId" i18n>Grad/Općina</label>
        <select [id]="'njuskalo-city-' + instanceId" [(ngModel)]="selectedCity"
                (change)="onCityChange($event)"
                [ngClass]="{ 'input-error': control.hasError('incompleteLocation') && !selectedCity }">
            <option value=""></option>
            <option *ngFor="let c of cities" [value]="c.city">{{ c.city }}</option>
        </select>
    </div>

    <div [hidden]="!showPlaces">
        <label [for]="'njuskalo-place-' + instanceId" *ngIf="showCities" i18n>Naselje</label>
        <label [for]="'njuskalo-place-' + instanceId" *ngIf="!showCities" i18n>Država</label>
        <select [id]="'njuskalo-place-' + instanceId" [(ngModel)]="selectedPlace"
                (change)="onPlaceChange($event)"
                [ngClass]="{ 'input-error': control.hasError('incompleteLocation') && !selectedPlace }">
            <option value=""></option>
            <option *ngFor="let place of places" [value]="'_' + place.id">{{ place.name }}</option>
        </select>
    </div>
    </div>

    <app-field-errors [control]="control" [hasToBeTouched]="false"></app-field-errors>
</div>
<div *ngIf="isLoadingTree">
    <div class="mb-4">
        <app-content-shimmer></app-content-shimmer>
    </div>
    <div class="mb-4">
        <app-content-shimmer></app-content-shimmer>
    </div>
    <div class="mb-4">
        <app-content-shimmer></app-content-shimmer>
    </div>
</div>
